import React, { MouseEventHandler } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { t, useGridProps } from '@/utils';

import styles from './privacy-policy-modal.module.scss';

export interface PrivacyPolicyModalProps {
  handleAccept: MouseEventHandler<HTMLElement>;
  handleHide: () => void;
  show: boolean;
}

const PrivacyPolicyModal = ({
  handleAccept,
  handleHide,
  show,
}: PrivacyPolicyModalProps) => {
  const { isMobile } = useGridProps();

  return (
    <>
      <Modal
        className={styles.modal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={handleHide}
        show={show}
        scrollable={isMobile}
        size="lg"
      >
        <Modal.Header
          className={styles.header}
          closeButton={isMobile}
          // closeVariant="white"
        >
          <Modal.Title id="contained-modal-title-vcenter" className={styles.title}>
            ㈜이노앤엠 개인정보처리방침
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.body}>
            <p className={styles.phrase}>
              주식회사 이노앤엠(“회사”또는 “이노앤엠”라 함)는 정보통신망 이용촉진 및
              정보보호 등에 관한 법률, 개인정보보호법, 통신비밀보호법, 전기통신사업법 등
              정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을
              준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에
              최선을 다하고 있습니다.
              <br />
              <br />
              1. 수집하는 개인정보의 항목 및 수집방법
              <br />
              2. 개인정보의 수집 및 이용목적
              <br />
              3. 개인정보 공유 및 제공
              <br />
              4. 개인정보의 보유 및 이용기간
              <br />
              5. 개인정보 파기절차 및 방법
              <br />
              6. 이용자 및 법정대리인의 권리와 그 행사방법
              <br />
              7. 개인정보 자동 수집 장치의 설치 / 운영 및 거부에 관한 사항
              <br />
              8. 개인정보의 기술적 / 관리적 보호 대책
              <br />
              9. 개인정보관리책임자 및 담당자의 연락처
              <br />
              10. 개인정보 처리 방침 변경
              <br />
              11. 고지의 의무
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>1. 수집하는 개인정보의 항목 및 수집방법</h5>
              <br />
              가. 수집하는 개인정보의 항목
              <br />
              첫째, 회사는 이용자에게 서비스를 제공하기 위해 아래와 같은 최소한의 고객의
              개인정보를 수집하고 있습니다.
              <br />
              [광고문의]
              <br />
              – 수집항목 : 이용자명(개인인 경우 이름, 개인사업자 또는 법인사업자인 경우
              상호명), 전화번호(휴대폰번호), 이메일이 수집됩니다.
              <br />
              둘째, 회사의 홈페이지를 접속하는 과정에서 아래와 같은 정보들이 자동으로
              생성되어 수집될 수 있습니다.
              <br />
              – IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록
              <br />
              셋째, 회사에서 제공하는 제품을 배송하기 위하여, 배송 받으실 주소를 수집할 수
              있습니다.
              <br />
              나. 개인정보 수집방법
              <br />
              회사는 다음과 같은 방법으로 개인정보를 수집합니다.
              <br />
              – 홈페이지 주소 문의자 이름, 업체명 , 유선 연락처 번호 , 무선 연락처 번호 ,
              이메일등
              <br />
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>2. 개인정보의 수집 및 이용목적</h5>
              <br />
              [마케팅 • 광고의 활용]
              <br />
              이벤트 등 광고성 정보 전달, 맞춤 서비스 제공, 통계학적 특성에 따른 서비스
              제공 및 광고 게재, 서비스의 유효성 확인, 접속빈도 파악 등 회사의 서비스
              이용에 대한 통계
              <br />
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>3. 개인정보의. 공유 및 제공</h5>
              <br />
              회사는 이용자들의 개인정보를 제 2항 ‘개인정보의 수집목적 및 이용목적’에서
              고지한 범위 내에서 사용하고, 이용자의 사전 동의 없이는 위 범위를 초과하여
              이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 그리고,
              이용자의 개인정보를 외부와 공유하는 경우에는 정보수집 또는 정보제공 이전에
              이용자들에게 개인정보를 공유할 기관이나 단체가 누구인지, 어떤 정보가 왜
              필요한지, 언제까지 어떻게 보호되고 관리되는지 알려드리고 동의를 구하는
              절차를 거치게 되며, 이용자들의 동의가 없는 경우에는 추가적인 정보를 임의로
              수집하거나 공유하지 않습니다.
              <br />
              다만, 아래의 경우에는 예외로 합니다.
              <br />
              가. 이용자가 사전에 동의한 경우
              <br />
              나. 통계작성, 학술연구 또는 시장조사를 위하여 개인을 식별할 수 없는 형태로
              제공하는 경우
              <br />
              다. 회사 이용 약관 또는 계약을 위반한 경우나 회사의 서비스를 이용하여
              타인에게 정신적, 물질적 피해를 줌으로써 글에 대한 법적인 조치를 취하기
              위하여 개인정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우
              <br />
              라. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라
              수사시관의 요구가 있는 경우
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>4. 개인정보의 보유 및 이용기간</h5>
              <br />
              이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체
              없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 보존 이유를 위해 명시한
              기간 동안 보존합니다.
              <br />
              가. 회사 내부 방침에 의한 정보 보유 기간
              <br />
              – 이용자의 정보 수집 및 이용 목적이 달성된 후 문의 내역관리를 위하여 문의
              내용과 개인정보 입력항목에 대해서는 6개월간 보유 합니다.
              <br />
              – 이용자와 회사간의 계약 종료 시 이용자의 개인정보는 계약기간이 종료된
              시점으로부터 1년간 보유 합니다.
              <br />
              – 회사가 이용자에게 견적을 제공한 후 계약이 체결되지 않았을 경우 이용자의
              개인정보는 견적을 제공한 시점으로부터 6개월간 보유 합니다.
              <br />
              나. 관련법령에 의한 정보 보유 기간
              <br />
              개인정보보호법 및 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하
              “정보통신망법”이라 합니다) 등 관계법령의 규정에 의하여 보존할 필요가 있는
              경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이
              경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와
              같습니다.
              <br />
              – 계약 또는 계약 종료 등에 관한 기록
              <br />
              보존 이유 : 하도급거래 공정화에 관한 법률 및 시행령
              <br />
              보존 기간 : 3년
              <br />
              – 웹사이트 방문기록
              <br />
              보존 이유 : 통신비밀보호법 시행령
              <br />
              보존 기간 : 3개월
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>5. 개인정보 파기절차 및 방법</h5>
              <br />
              이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체
              없이 파기 합니다,
              <br />
              회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
              <br />
              가. 파기절차
              <br />
              – 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로
              옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한
              정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기 됩니다.
              <br />
              – 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로
              이용되지 않습니다.
              <br />
              나. 파기방법
              <br />
              – 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
              <br />– 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적
              방법을 사용하여 삭제합니다.
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>
                6. 이용자의 정보주체의 권리와 그 행사 방법
              </h5>
              <br />
              – 이용자 개인 정보 열람 요구 시 회사는 지체 없이 열람하겠습니다.
              <br />
              – 이용자 오류 등이 있을 경우 정정 요구 시 회사는 지체 없이 정정하겠습니다.
              <br />
              – 이용자 개인 정보 삭제 요구 시 회사는 지체 없이 삭제하겠습니다.
              <br />
              – 개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락해주시면 지체 없이
              조치하겠습니다.
              <br />
              – 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 완료하기 전까지
              당해 개인정보를 이용 또는 제공하지 않습니다.
              <br />– 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 제 4.항
              ‘개인정보의 보유 및 이용기간’에 명시된 바에 따라 처리하고, 그 외의 용도로
              열람 또는 이용할 수 없도록 처리하고 있습니다.
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>
                7. 개인정보 자동 수집 장치의 설치 / 운영 및 거부에 관한 사항
              </h5>
              <br />
              가. 쿠키란?
              <br />
              – 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를
              저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.
              <br />
              – 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는
              아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다. 이후
              이용자가 웹 사이트에 방문할 경우 웹 사이트 서버는 이용자의 하드 디스크에
              저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된
              서비스를 제공하기 위해 이용됩니다.
              <br />
              – 쿠키는 개인을 식별하는 정보를 자동적 / 능동적으로 수집하지 않으며,
              이용자는 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다.
              <br />
              나. 회사의 쿠키 사용 목적
              <br />
              이용자의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야 파악 및
              자취 추적, 각종 이벤트 참여 정도 및 방문 횟수 파악 등을 통한 타겟 마케팅 및
              개인 맞춤 서비스 제공을 위해 사용합니다.
              <br />
              다. 쿠키의 설치 / 운영 및 거부
              <br />
              – 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는
              웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될
              때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수 있습니다.
              <br />
              – 쿠키 설치 허용 여부를 지정하는 방법(Internet Explorer의 경우)은 다음과
              같습니다.
              <br />
              ① [도구] 메뉴에서 [인터넷 옵션]을 선택합니다.
              <br />
              ② [개인정보 탭]을 클릭합니다.
              <br />③ [개인정보처리 수준]을 설정하시면 됩니다.
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>8. 개인정보의 기술적 / 관리적 보호 대책</h5>
              <br />
              회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조
              또는 훼손 되지 않도록 안정성 확보를 위하여 다음과 같은 기술적 / 관리적
              대책을 강구하고 있습니다.
              <br />
              가. 개인정보 암호화
              <br />
              이용자 및 고객의 개인정보는 고도몰 웹호스팅 서비스를 통해 저장 및 관리되고
              있습니다.
              <br />
              나. 해킹 등에 대비한 대책
              <br />
              회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나
              훼손되는 것을 막기 위해 최선을 다하고 있습니다.
              <br />
              개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을
              이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지 않도록 방지하고
              있습니다.
              <br />
              다. 처리 직원의 최소화 및 교육
              <br />
              회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위해 담당자에
              대한 수시 교육을 통하여 개인정보처리방침의 준수를 항상 강조하고 있습니다.
              <br />
              라. 개인정보보호전담기구의 운영
              <br />
              그리고 사내 개인정보보호전담 부서 등을 통하여 개인정보처리방침의 이행사항 및
              담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수
              있도록 노력하고 있습니다.
              <br />
              단, 회사가 개인정보보호 의무를 다 하였음에도 불구하고 이용자 본인의 부주의나
              회사가 관리하지 않는 영역에서의 사고 등 회사의 귀책에 기인하지 않은 손해에
              대해서는 회사는 책임을 지지 않습니다.
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>
                9. 개인정보관리책임자 및 담당자의 연락처
              </h5>
              <br />
              귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을
              개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.
              <br />
              회사는 이용자 등의 신고사항에 대해 신속하고 충분한 답변을 드릴 것입니다.
              <br />
              [개인정보 보호책임자]
              <br />성 명 : 박 관 희
              <br />소 속 : ㈜{t(`company.brandKO`)}
              <br />전 화 : 010-3928-8492
              <br />
              이메일 : {t(`company.contactEmail`)}
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>10. 개인정보 처리 방침 변경</h5>
              <br />
              본 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의
              추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을
              통하여 고지할 것입니다.
              <br />
              기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에
              문의하시기 바랍니다.,
              <br />
              – 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)
              <br />
              – 대검찰청 사이버범죄수사단 (www.spo.go.kr / 02-3480-3571)
              <br />
              – 경찰청 사이버안전국 (www.ctrc.go.kr / 국번없이 182)
              <br />– 개인정보마크인증위원회(www.epivacy.or.kr / 02-580-0533 ~ 4)
            </p>
            <p className={styles.phrase}>
              <h5 className={styles.subtitle}>11. 고지의 의무</h5>
              <br />
              본 개인정보처리방침은 2021년 7월 15일부터 시행합니다.
              <br />본 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소
              7일전부터 홈페이지를 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용,
              제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일
              전에 고지합니다.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.footer}>
          <Button className={styles.button} size="lg" onClick={handleAccept}>
            동의합니다
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PrivacyPolicyModal;
